// extracted by mini-css-extract-plugin
module.exports = {"emptyTableContainer":"EmptyTableMessage_emptyTableContainer__2zmeT"};